import Content from '../../content.js';

namespace('IO.Views.OwnershipTransfers', function (exports) {
  'use strict';

  var New = Content.extend({
    dom: {
      FROM_NODE_NUMBER_INPUT: '#ownership_transfer_from_node_number',
      TO_NODE_NUMBER_INPUT: '#ownership_transfer_to_node_number',
      DELETE_NODES_SWITCH: '#opt_delete_nodes',
    },

    events: function () {
      var events = {};

      events['keydown ' + this.dom.FROM_NODE_NUMBER_INPUT] =
        '_allowOnlyNumbers';
      events['keydown ' + this.dom.TO_NODE_NUMBER_INPUT] = '_allowOnlyNumbers';
      events['keyup ' + this.dom.FROM_NODE_NUMBER_INPUT] =
        '_updateDeleteAllOption';
      events['keyup ' + this.dom.TO_NODE_NUMBER_INPUT] =
        '_updateDeleteAllOption';

      return events;
    },

    _allowOnlyNumbers(event) {
      if (event.key.length === 1 && /\D/.test(event.key)) {
        event.preventDefault();
      }
    },

    _updateDeleteAllOption: function () {
      const sameValue =
        $(this.dom.FROM_NODE_NUMBER_INPUT)[0].value ===
          $(this.dom.TO_NODE_NUMBER_INPUT)[0].value &&
        !($(this.dom.FROM_NODE_NUMBER_INPUT)[0].value === '');

      if (sameValue) {
        $(this.dom.DELETE_NODES_SWITCH + ':checked').prop('checked', false);
      }

      $(this.dom.DELETE_NODES_SWITCH).attr('disabled', sameValue);
    },
  });

  exports.New = New;
});
